import { gql } from "@apollo/client";

export const addUserQuestionnairesAnswers = gql`
  mutation addUserQuestionnaireAnswers($name : String!, $answers : [AnswerOptionsInput]!) {
    userQuestionnaireAnswer_CreateOne(name: $name, answers : $answers) {
      _id
    }
  }
`;

export const editUserQuestionnairesAnswers = gql`
  mutation editUserQuestionnaireAnswers($id: String!, $name : String!, $answers : [AnswerOptionsInput]!) {
    userQuestionnaireAnswer_UpdateById(id :$id, name: $name, answers: $answers) {
      _id
    }
  }
`;

export const removeUserQuestionnairesAnswers = gql`
  mutation removeUserQuestionnaireAnswers($_id: MongoID!) {
    userQuestionnaireAnswer_RemoveById(_id :$_id) {
      _id
    }
  }
`;